import React from "react";
import {
  Paper,
  styled,
  Typography,
  useTheme,
} from "@mui/material";

import { UseFormReturn } from "react-hook-form";
import { addressDetailsFields } from "../fieldData";
import { useQuery, useQueryClient } from "react-query";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import {
  getAddressType,
  getReligion,
  getStates,
} from "../registrationServices";
import { CountryType } from "../type/RegistrationDataType";
import { ResponseType } from "../../../../Types/ServicesType/servicesType";

interface AddressDetailsProps {
  formControls: UseFormReturn<any>;
}

const StyledTextField = styled("div")(({}) => ({
  "& .MuiTextField-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      width: 110,
      paddingX: 0,
    },
  },
  // },
}));

const StyledSelect = styled("div")(({}) => ({
  "& .MuiFormControl-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      borderLeft: 0,
      // "& fieldset": {
      //   borderLeftWidth: 0,
      // },
    },
  },
  // },
}));

const AddressDetails: React.FC<AddressDetailsProps> = ({ formControls }) => {
  const theme = useTheme();
  const { control, watch, setValue } = formControls;
  const country = watch(addressDetailsFields.country.name);
  const queryClient = useQueryClient();

  const { data: addressTypes, isLoading: addressTypeLoading } = useQuery(
    ["getAddressType"],
    getAddressType,
    {
      refetchOnWindowFocus: false,
    }
  );

  const countries = queryClient.getQueryData(["getCountry"]) as ResponseType<
    CountryType[]
  >;

  const { data: states, isLoading: stateLoading } = useQuery(
    ["getStates", country],
    async () => {
      return await getStates(country.id);
    },
    {
      refetchOnWindowFocus: false,
    }
  );
  const { data: religion, isLoading: religionLoading } = useQuery(
    ["getReligion"],
    getReligion,
    {
      refetchOnWindowFocus: false,
    }
  );

  const onChange = ({
    target,
  }: {
    type: string;
    target: { value: any; name: string };
  }) => {
    if (target.name == addressDetailsFields.country.name) {
      target?.value?.id == "172"
        ? setValue(addressDetailsFields.state.name, {
            countryId: 172,
            stateName: "Qatar",
            stateId: 51,
            stateCode: "RAK",
            stateStatus: 1,
          })
        : setValue(addressDetailsFields.state.name, {
          countryId: 0,
          stateName: "",
          stateId: 0,
          stateCode: "",
          stateStatus: 0,
        });
    }
  };

  return (
    <div>
      <div className="relative top-4 left-3 bg-green-600 w-fit px-1 rounded">
        <Typography
          gutterBottom
          component="div"
          fontSize={15}
          color={theme.palette.background.paper}
        >
          Address details
        </Typography>
      </div>
      <Paper className="pt-3 h-full">
        <div className="p-3 grid grid-cols-2 gap-3">
          <CustomFormField control={control} {...addressDetailsFields.adress} />
          <CustomFormField
            control={control}
            {...addressDetailsFields.addressType}
            options={addressTypes?.response || []}
            autocompleteProps={{
              ...addressDetailsFields.addressType.autocompleteProps,
              loading: addressTypeLoading,
            }}
          />
          <CustomFormField
            control={control}
            {...addressDetailsFields.country}
            options={countries?.response || []}
            // loading={countryLoading}
            autocompleteProps={{
              ...addressDetailsFields.country.autocompleteProps,
              // loading: countryLoading,
            }}
            fieldProps={{
              ...addressDetailsFields.country.fieldProps,
            }}
            rules={{
              ...addressDetailsFields.country.rules,
              onChange,
            }}
          />
          <CustomFormField
            control={control}
            {...addressDetailsFields.state}
            options={states?.response || []}
            autocompleteProps={{
              ...addressDetailsFields.state.autocompleteProps,
              loading: stateLoading,
            }}
          />
          <CustomFormField
            control={control}
            {...addressDetailsFields.nationality}
            options={countries?.response || []}
            // loading={countryLoading}
            autocompleteProps={{
              ...addressDetailsFields.nationality.autocompleteProps,
              // loading: countryLoading,
              // filterOptions:option=>option
            }}
            fieldProps={{
              ...addressDetailsFields.nationality.fieldProps,
              // onChange: debouncedHandleSearch,
            }}
            rules={{
              ...addressDetailsFields.nationality.rules,
            }}
          />

          <CustomFormField
            control={control}
            {...addressDetailsFields.cityOrPlace}
          />

          <div className="flex">
            <StyledTextField>
              <CustomFormField
                control={control}
                {...addressDetailsFields.code}
                options={countries?.response || []}
                // loading={countryLoading}
              />
            </StyledTextField>
            <StyledSelect className="w-full">
              <CustomFormField
                control={control}
                {...addressDetailsFields.mobile}
              />
            </StyledSelect>
          </div>
          <CustomFormField control={control} {...addressDetailsFields.email} />
         <div className="hidden">
            <CustomFormField
              control={control}
              {...addressDetailsFields.religion}
              options={religion?.response || []}
              fieldProps={{
                ...addressDetailsFields.religion.fieldProps,
              }}
              autocompleteProps={{
                ...addressDetailsFields.religion.autocompleteProps,
                loading: religionLoading,
              }}
            />
          </div>
        </div>
      </Paper>
    </div>
  );
};

export default AddressDetails;
